/**
 * 外勤蜂客服 WebSocket 协议（对齐小程序 shopro/mixins/appwebspcket.js）
 */
import store from '@/store'

const wsMarks = {
  globalLoginKey: '',
  sessionLoginKey: '',
  readSessionId: ''
}

export function resetWsMarksOnReconnect() {
  wsMarks.globalLoginKey = ''
  wsMarks.sessionLoginKey = ''
  wsMarks.readSessionId = ''
}

export function clearChatSessionMarks() {
  wsMarks.sessionLoginKey = ''
  wsMarks.readSessionId = ''
}

function getUserId() {
  const info = (store.getters.userInfo || {}) 
  return info.id || info.user_id || ''
}

function getSessionLoginKey(options = {}) {
  const userId = options.user_id != null ? options.user_id : getUserId()
  return [
    userId || '',
    options.tax_chat_pool_id || '',
    options.to_user_id || '',
    options.session_id || ''
  ].join(':')
}

export function shouldSendGlobalLogin(payload = {}) {
  const key = `global:${payload.user_id || ''}`
  if (wsMarks.globalLoginKey === key) return false
  wsMarks.globalLoginKey = key
  return true
}

export function shouldSendSessionLogin(options = {}) {
  if (!options.tax_chat_pool_id && !options.session_id) return false
  const isPrivate = options.is_private || options.isPrivate
  const key = isPrivate
    ? `private:${getSessionLoginKey(options)}`
    : getSessionLoginKey({ ...options, session_id: options.session_id || '' })
  if (wsMarks.sessionLoginKey === key) return false
  wsMarks.sessionLoginKey = key
  return true
}

export function shouldSendSessionRead(sessionId) {
  const id = String(sessionId || '')
  if (!id || id === '0') return false
  if (wsMarks.readSessionId === id) return false
  wsMarks.readSessionId = id
  return true
}

/** 全局 / 群聊 login */
export function buildLoginMessage(options = {}) {
  const payload = { type: 'login' }
  const userId = options.user_id != null ? options.user_id : getUserId()
  if (userId != null && userId !== '') payload.user_id = Number(userId)
  if (options.to_user_id != null && options.to_user_id !== '') {
    payload.to_user_id = Number(options.to_user_id)
  }
  if (options.tax_chat_pool_id) payload.tax_chat_pool_id = Number(options.tax_chat_pool_id)
  if (options.session_id) payload.session_id = Number(options.session_id)
  return payload
}

/** 私聊 login（可带 session_id 加入会话） */
export function buildPrivateLoginMessage({ to_user_id, tax_chat_pool_id, session_id } = {}) {
  return buildLoginMessage({
    to_user_id,
    tax_chat_pool_id,
    session_id
  })
}

export function isPrivateSessionType(type) {
  return String(type) === '1'
}

export function buildPrivateChatMessage({
  to_user_id,
  tax_chat_pool_id,
  message,
  message_type = 'text'
}) {
  return {
    type: 'chat',
    to_user_id: Number(to_user_id),
    tax_chat_pool_id: Number(tax_chat_pool_id),
    message,
    message_type
  }
}

export function buildGroupChatMessage({
  session_id,
  tax_chat_pool_id,
  message,
  message_type = 'text'
}) {
  const payload = {
    type: 'chat',
    session_id: Number(session_id),
    message,
    message_type
  }
  if (tax_chat_pool_id) payload.tax_chat_pool_id = Number(tax_chat_pool_id)
  return payload
}

/** 单聊绝不带 session_id */
export function buildChatMessage(options = {}) {
  const { message, message_type = 'text' } = options
  if (isPrivateSessionType(options.session_type)) {
    return buildPrivateChatMessage({
      to_user_id: options.to_user_id,
      tax_chat_pool_id: options.tax_chat_pool_id,
      message,
      message_type
    })
  }
  if (options.session_id) {
    return buildGroupChatMessage({
      session_id: options.session_id,
      tax_chat_pool_id: options.tax_chat_pool_id,
      message,
      message_type
    })
  }
  return buildPrivateChatMessage({
    to_user_id: options.to_user_id,
    tax_chat_pool_id: options.tax_chat_pool_id,
    message,
    message_type
  })
}

export function buildReadMessage({ session_id }) {
  return {
    type: 'read',
    session_id: Number(session_id)
  }
}
